import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

export const InsufficientCreditsDialog: React.FC<{open: boolean; onClose: () => void; purpose?:'download'|'processing'}> = ({open, onClose,purpose='processing'}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" aria-labelledby="insufficient-credits-title" aria-describedby="insufficient-credits-description"
    PaperProps={{sx: {borderRadius: 3, p: {xs: 1, sm: 3}}}}>
    <DialogTitle id="insufficient-credits-title" sx={{textAlign: 'center', fontSize: {xs: '1.6rem', sm: '2rem'}, fontWeight: 700}}>
      <Box sx={{display: 'flex', justifyContent: 'center', mb: 2}}><AccountBalanceWalletOutlinedIcon sx={{fontSize: 56, color: '#c74375'}} /></Box>
      You need more credits
    </DialogTitle>
    <DialogContent>
      <Typography id="insufficient-credits-description" sx={{textAlign: 'center', fontSize: '1.1rem'}}>
        {purpose==='download' ? 'Add credits to clear your negative balance before downloading. One-time purchases are available without a subscription.' : 'Buy one-time credits to cover your next capture and pending captures. No subscription required.'}
      </Typography>
    </DialogContent>
    <DialogActions sx={{justifyContent: 'center', gap: 1, pb: 2, flexWrap: 'wrap'}}>
      <Button onClick={onClose}>Not now</Button>
      <Button href="/plans" variant="contained" size="large" sx={{backgroundColor: '#c74375', '&:hover': {backgroundColor: '#b83565'}}}>View plans &amp; buy credits</Button>
    </DialogActions>
  </Dialog>
);
